module.exports = __webpack_public_path__ + "static/img/齐飞.26424b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/st/齐飞.jpg
// module id = x272
// module chunks = 1